module.exports = __webpack_public_path__ + "img/product-img2.6ea29ac7.png";